<template>
	<el-main>
		<div class="mybread">
			<p><i class="el-icon-location"></i>当前位置：</p>
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>其他管理</el-breadcrumb-item>
				<el-breadcrumb-item>物品管理</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<div class="form">
			<el-form ref="form" label-width="100px" label-position="left">
				<el-form-item label="" style="margin-left: -100px;">
					<el-col :span="5">
						<el-select v-model="form.atype" placeholder="请输入" style="margin-right: 0; width: 100%;">
							<el-option label="物品名称" value="asset_name" checked></el-option>
							<el-option label="物品编号" value="asset_code" checked></el-option>
							<el-option label="固定资产编号" value="fixed_asset_no" checked></el-option>
							<el-option label="领用人" value="receive_user" checked></el-option>
						</el-select>
					</el-col>
					<el-col :span="12" style="margin-right: 10px;">
						<el-input placeholder="请输入内容" v-model="form.key" @keyup.enter.native="search" clearable @clear="search">
						</el-input>
					</el-col>
					<el-col :span="2">
						<el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
					</el-col>
				</el-form-item>

				<el-form-item label="购置时间：" prop="time">
					<el-col :span="12">
						<el-date-picker v-model="form.purchase_time" type="datetimerange" range-separator="--" start-placeholder="开始日期"
							end-placeholder="结束日期" style="width: 58%;margin-right: 10px;" @change="search(false)">
						</el-date-picker>
					</el-col>
				</el-form-item>

				<el-form-item label="筛选：" prop="type">
					<el-col :span="3" style="margin-right: 20px;">
						<el-cascader v-model="form.category_ids" :options="officeTypeList"
							:props="{ expandTrigger: 'hover', checkStrictly: false }" @change="v => handleofficeChange(v)"
							style="width: 100%;" clearable></el-cascader>
					</el-col>

					<el-col :span="3" style="margin-right: 20px;">
						<el-select v-model="form.belong_type" placeholder="物品归属" style="margin-right: 0; width: 100%;" clearable
							@change="search(false)">
							<el-option label="项目" value="1"></el-option>
							<el-option label="行政" value="2"></el-option>
						</el-select>
					</el-col>
					<el-col :span="3" style="margin-right: 20px;">
						<el-select v-model="form.status" placeholder="物品状态" style="margin-right: 0; width: 100%;" clearable
							@change="search(false)">
							<el-option label="正常" value="1"></el-option>
							<el-option label="维修" value="2"></el-option>
							<el-option label="过期" value="3"></el-option>
						</el-select>
					</el-col>
					<el-col :span="3" style="margin-right: 20px;">
						<el-select v-model="form.use_status" placeholder="领用状态" style="margin-right: 0; width: 100%;" clearable
							@change="search(false)">
							<el-option label="在库" value="0"></el-option>
							<el-option label="领用" value="1"></el-option>
							<el-option label="部分领用" value="2"></el-option>
						</el-select>
					</el-col>
				</el-form-item>

				<el-form-item label="已选条件">
					<el-tag v-for="tag in tags" :key="tag.key" effect="dark" closable @close="removeTag(tag)">
						{{ tag.key }}: {{ tag.value }}
					</el-tag>
				</el-form-item>
			</el-form>
		</div>

		<div class="table">
			<div class="filterwrap">
				<div class="filter">
					<el-checkbox-group class="filtergroup" v-model="checkList" prop="checkList" :min="5">
						<el-checkbox label="物品编号"></el-checkbox>
						<el-checkbox label="物品名称"></el-checkbox>
						<el-checkbox label="序列码"></el-checkbox>
						<el-checkbox label="物品分类"></el-checkbox>
						<el-checkbox label="物品归属"></el-checkbox>
						<el-checkbox label="物品总数"></el-checkbox>
						<el-checkbox label="可用数量"></el-checkbox>
						<el-checkbox label="物品类型"></el-checkbox>
						<el-checkbox label="购置金额"></el-checkbox>
						<el-checkbox label="购置时间"></el-checkbox>
						<el-checkbox label="物品状态"></el-checkbox>
						<el-checkbox label="固定资产编号"></el-checkbox>
						<el-checkbox label="固定资产状态"></el-checkbox>
						<el-checkbox label="领用状态"></el-checkbox>
						<el-checkbox label="领用人"></el-checkbox>
						<el-checkbox label="关联项目"></el-checkbox>
					</el-checkbox-group>
				</div>
				<div class="btnarea">
					<el-button icon="el-icon-plus" @click="link('/asset/add')" v-if="NodeInclude('396')">新增</el-button>
					<el-button @click="exportAssetList" v-if="NodeInclude('400')">导出数据</el-button>
				</div>
			</div>

			<el-table :data="itemList" border stripe style="width: 100%;" highlight-current-row
				:row-class-name="tableRowClassName">
				<el-table-column prop="asset_code" label="物品编号" header-align="center" align="center" width="150"
					v-if="check('物品编号')">
					<template slot-scope="scope">
						<div class="contract-no" @click="showColorPan(scope)">
							<div>
								<div class="circle">
									<div class="circle-color" :style="{ 'background': scope.row.mark_color }"></div>
								</div>
								<div>{{ scope.row.asset_code }}</div>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="asset_name" label="物品名称" header-align="center" align="left" min-width="350"
					v-if="check('物品名称')">
					<template slot-scope="scope">
						<div>{{ scope.row.asset_name }} {{ scope.row.secondary_name ? `- ${scope.row.secondary_name}` : '' }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="serial_no" label="序列码" header-align="center" align="center" width="200"
					v-if="check('序列码')">
					<template slot-scope="scope">
						<div>{{ scope.row.serial_no ? scope.row.serial_no : '暂无' }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="cate_name" label="物品分类" header-align="center" align="center" width="180"
					v-if="check('物品分类')" />
				<el-table-column prop="cate_name" label="物品归属" header-align="center" align="center" width="100"
					v-if="check('物品归属')">
					<template slot-scope="scope">
						{{ dd.assetbelong_type[scope.row.belong_type] }}
					</template>
				</el-table-column>
				<el-table-column prop="asset_count" label="物品总数" header-align="center" align="center" width="80"
					v-if="check('物品总数')" />
				<el-table-column prop="available_count" label="可用数量" header-align="center" align="center" width="80"
					v-if="check('可用数量')" />
				<el-table-column prop="status" label="物品类型" header-align="center" align="center" width="100"
					v-if="check('物品类型')">
					<template slot-scope="scope">
						{{ scope.row.is_consumable == '0' ? (scope.row.is_fixed == '1' ? '固定资产' : '非消耗品') : '消耗品' }}
					</template>
				</el-table-column>
				<el-table-column prop="asset_price" label="购置金额" header-align="center" align="center" width="150"
					v-if="check('购置金额')" />
				<el-table-column prop="purchase_date" label="购置时间" header-align="center" align="center" width="100"
					v-if="check('购置时间')" />
				<el-table-column prop="status" label="物品状态" header-align="center" align="center" width="100"
					v-if="check('物品状态')">
					<template slot-scope="scope">
						<div class="circle-tag" :style="{ 'background': dd.assetStatus_c[scope.row.status]?.color }">
							<div class="word">{{ dd.assetStatus_c[scope.row.status]?.word }}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="fixed_asset_no" label="固定资产编号" header-align="center" align="center" width="150"
					v-if="check('固定资产编号')">
					<template slot-scope="scope">
						{{ scope.row.fixed_asset_no && scope.row.fixed_asset_no != '' ? scope.row.fixed_asset_no : '暂无' }}
					</template>
				</el-table-column>
				<el-table-column prop="fixed_asset_no" label="固定资产状态" header-align="center" align="center" width="100"
					v-if="check('固定资产状态')">
					<template slot-scope="scope">
						<div class="circle-tag" :style="{ 'background': dd.assetStayStatus_c[0]?.color }"
							v-if="scope.row.is_fixed != '1'">
							<div class="word">{{ dd.assetStayStatus_c[0]?.word }}</div>
						</div>
						<div class="circle-tag" :style="{ 'background': dd.assetStayStatus_c[scope.row.asset_status]?.color }"
							v-else>
							<div class="word">{{ dd.assetStayStatus_c[scope.row.asset_status]?.word }}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="status" label="领用状态" header-align="center" align="center" width="100"
					v-if="check('领用状态')">
					<template slot-scope="scope">
						<div class="circle-tag" :style="{ 'background': dd.assetUseStatus_c[3]?.color }"
							v-if="scope.row.status == '3'">
							<div class="word">{{ dd.assetUseStatus_c[3]?.word }}</div>
						</div>
						<div class="circle-tag" :style="{ 'background': dd.assetUseStatus_c[scope.row.use_status]?.color }" v-else>
							<div class="word">{{ dd.assetUseStatus_c[scope.row.use_status]?.word }}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="status" label="领用人" header-align="center" align="center" width="150" v-if="check('领用人')">
					<template slot-scope="scope">
						<div v-if="scope.row.current_user?.length != 0">{{ scope.row.current_user[0]?.realname }} {{
							scope.row.current_user[0]?.en_name }} {{ scope.row.current_user?.length > 1 ? '...' : '' }}</div>
						<div v-else>暂无领用</div>
					</template>
				</el-table-column>
				<el-table-column prop="status" label="关联项目" header-align="center" align="center" width="180"
					v-if="check('关联项目')">
					<template slot-scope="scope">
						<div class="linkwrap normal" v-if="Object.keys(scope.row.project_pay_info)?.length">
							<el-link type='primary' class="link"
								@click.stop="link(scope.row.project_pay_info?.m_type == '1' ? `/project/detail?id=${scope.row.project_pay_info?.project_id}` : `/admin/view?id=${scope.row.project_pay_info?.project_id}&mType=2`)">{{
									scope.row.project_pay_info?.contract_no }}</el-link>
						</div>
						<div v-else>暂无</div>
					</template>
				</el-table-column>

				<el-table-column prop="" label="操作" header-align="center" width="100" align="center" fixed="right"
					v-if="NodeInclude('396') || NodeInclude('399')">
					<template slot-scope="scope">
						<div class="linkwrap">
							<el-link type='primary' class="link" @click="handleClick(scope.row)"
								v-if="NodeInclude('396')">编辑</el-link>
							<el-link type='primary' class="link" @click="handleView(scope.row)" v-if="NodeInclude('399')">查看</el-link>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="apage">
				<el-pagination @current-change="handleCurrentChange" :current-page="p" :page-size="30"
					layout="total, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
			<el-dialog title="选择颜色" :visible.sync="colorPanShow" width="400px">
				<div class="color-pan">
					<ul>
						<li @click="markProjectColor(i.color)" v-for="i, d in dd.color_pan" :key="`color${d}`"
							:style="{ 'background': i.color }">
							<span v-if="i.color == colorData.color"><i class="el-icon-close"></i></span>
							<span v-else><i class="el-icon-check"></i></span>
						</li>
					</ul>
				</div>
			</el-dialog>
		</div>
	</el-main>
</template>

<script>
// CodeToText
import * as api from '@/api'
// import { thousands } from '@/utils/index.js'
import store from '@/store'
export default {
	name: 'asset',
	data() {
		return {
			nodeLimtList: [],
			level: '',
			userId: '',
			officeTypeList: [],
			categoryNameMap: {}, //存储分类ID到名称的映射
			checkList: [
				'物品编号',
				'物品名称',
				'序列码',
				'物品分类',
				'物品归属',
				'物品总数',
				'可用数量',
				'物品类型',
				'购置金额',
				'购置时间',
				'物品状态',
				'固定资产编号',
				'固定资产状态',
				'领用状态',
				'领用人',
				'关联项目',
			],
			yearList: [],
			itemList: [],
			total: 0,
			perPage: 30,
			p: 1,
			form: {
				key: '',
				atype: 'asset_code',
				purchase_time: ['', ''],
			},
			colorPanShow: false,
			colorData: {},
		}
	},
	computed: {
		tags() {
			let temp = [
				{
					key: this.dd.assetType[this.form.atype],
					val: 'atype',
					value: this.form.key,
					active: !!this.form.atype && !!this.form.key,
				},
				{
					key: '物品归属',
					val: 'belong_type',
					value: this.dd.assetbelong_type[this.form.belong_type],
					active: !!this.form.belong_type,
				},
				{
					key: '物品状态',
					val: 'status',
					value: this.dd.assetStatus[this.form.status],
					active: !!this.form.status,
				},
				{
					key: '物品状态',
					val: 'status',
					value: this.dd.assetUseStatus[this.form.use_status],
					active: !!this.form.status,
				},
				{
					key: '分类',
					val: 'category_ids',
					// 获取选中分类的完整中文路径（如：一级分类 / 二级分类）
					value: this.getCategoryNames(this.form.category_ids),
					active: !!this.form.category_ids && this.form.category_ids.length > 0,
				},
				{
					key: '购置时间',
					val: 'purchase_time',
					value: this.dateValue(this.form.purchase_time),
					active: !!this.form.purchase_time && this.form.purchase_time[0] && !!this.form.purchase_time && this.form.purchase_time[1],
				},
			]
			temp = temp.filter((item) => item.active)
			return temp
		},
	},
	created() {

	},
	mounted() {
		this.getStoreFn()
	},
	methods: {
		// 递归构建分类ID到名称的映射表
		buildCategoryNameMap(options) {
			options.forEach(item => {
				// 存储当前分类的ID和名称映射
				this.categoryNameMap[item.id || item.value] = item.name || item.label || item.title;
				// 递归处理子分类
				if (item.children && item.children.length > 0) {
					this.buildCategoryNameMap(item.children);
				}
			});
		},
		// 根据ID数组获取完整的中文名称路径
		getCategoryNames(idArray) {
			if (!Array.isArray(idArray) || idArray.length === 0) return '';
			// 遍历ID数组，获取每个ID对应的名称，然后用 / 连接
			return idArray.map(id => this.categoryNameMap[id] || id).join(' / ');
		},
		checkUrlFn() {
			// 获取当前URL的哈希部分
			const hash = window.location.hash;
			// 移除'#'字符
			const url = hash.substring(1);

			let postData = {
				url_path: url
			}
			api.checkLoginUrl(postData).then((res) => {
				if (res.status == 400) {
					this.$message({
						type: 'info',
						message: '暂无权限',
					})
					this.$router.push({
						path: `/home`
					});
				}
			})
		},
		checkNodeFn(menu_id) {
			let postData = {
				menu_id,
			}
			api.checkNode(postData).then((res) => {
				this.nodeLimtList = res.node_ids.split(',')
			})
		},
		NodeInclude(val) {
			return this.nodeLimtList.includes(val)
		},
		exportAssetList() {
			window.location = api.exportAssetList({
				...this.form,
				[this.form.atype]: this.form.key,//搜索
				purchase_time_from: this.fdate(this.form.purchase_time[0]) || '',
				purchase_time_to: this.fdate(this.form.purchase_time[1]) || '',
			})
		},
		dateValue(dateArr) {
			if (Array.isArray(dateArr)) {
				return this.fdate(dateArr[0]) + '-' + this.fdate(dateArr[1])
			} else {
				return ''
			}
		},
		check(key) {
			return this.checkList.includes(key)
		},
		link(url) {
			this.$router.push(url)
		},
		getOfficeType() {
			const that = this;
			return new Promise(function (resolve) {
				that.$fly.post("apiAsset_getAssetTypeDownList.html", {}).then((res) => {
					that.officeTypeList = res.length ? res : [];
					// 关键修改：构建分类名称映射表
					that.buildCategoryNameMap(that.officeTypeList);
					resolve(that.officeTypeList)
				});
			})
		},
		handleClick(item) {
			this.$router.push({
				path: '/asset/add',
				query: { id: item.id },
			})
		},

		handleView(item) {
			this.$router.push({
				path: '/asset/view',
				query: { id: item.id },
			})
		},

		search() {
			this.p = 1
			store.commit('setAssetData', JSON.parse(JSON.stringify(this.form)))
			this.getList()
		},

		getStoreFn() {
			this.form = Object.keys(store.state.assetData).length != 0 ? store.state.assetData : this.form
			this.getOfficeType().then(() => {
				this.getList()
			})
		},

		getList() {
			this.checkUrlFn()
			this.checkNodeFn('61')
			const purchase_time = this.form.purchase_time || []
			const postData = {
				...this.form,
				p: this.p,
				per_page: this.perPage,
				[this.form.atype]: this.form.key,//搜索
				purchase_time_from: this.fdate(purchase_time[0]),
				purchase_time_to: this.fdate(purchase_time[1]),
			}
			api.AssetList(postData).then((res) => {
				this.itemList = res.itemList
				this.total = +res.totalNum
				setTimeout(() => {
					//权限
					this.level = store.state.level
					this.userId = store.state.userId
				}, 200);
			})
		},

		removeTag(tag) {
			if (tag.val === 'category_ids') {
				this.form.category_ids = []
				this.form.cate_id = undefined
			}
			else if (tag.val === 'purchase_time') {
				this.form.purchase_time = ['', '']
			}
			!{
				type: () => {
					this.form['key'] = undefined
				},
			}[tag.val]?.()
			this.form[tag.val] = ''
			this.form.key = this.form.atype == '' ? '' : this.form.key
			store.commit('setAssetData', JSON.parse(JSON.stringify(this.form)))
			this.getList()
		},

		handleCurrentChange(p) {
			this.p = p
			store.commit('setAssetData', JSON.parse(JSON.stringify(this.form)))
			this.getList()
		},
		handleofficeChange(v) {
			const trueId = v[v.length - 1]
			this.form.cate_id = trueId
			this.form.category_ids = v
			this.getList()
		},
		showColorPan({ row }) {
			const index = this.itemList.indexOf(row)
			this.colorData = {
				project_id: row.id,//项目id就是资产id
				mType: 7,
				color: row.mark_color,
				id: row.markArr?.id,
				option: row.markArr?.id ? '2' : '1',
				index: index,
			}
			this.colorPanShow = true
		},
		markProjectColor(color) {
			const index = this.colorData.index
			const postData = {
				...this.colorData,
				mark_color: color == this.colorData.color ? '' : color, //同色取消
			}
			delete postData.color
			delete postData.index
			api.markProjectList(postData).then(() => {
				this.colorPanShow = false
				this.itemList[index].mark_color = color == this.colorData.color ? '' : color //同色取消
				// this.getList()
			})
		},
		tableRowClassName({ row }) {
			if (row.status == "3") {
				return "warning-row";
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.filterwrap {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	padding: 0 0 20px 0;

	.filter {
		width: 85%;
	}

	.btnarea {
		box-sizing: border-box;
		width: 15%;
		padding: 0 20px;
		display: flex;
		justify-content: flex-end;
	}
}

.el-checkbox-group.filtergroup .el-checkbox {
	width: auto;
}

.apage {
	background: var(--bg); /* 0819修改 */
	padding: 8px;
	text-align: right;
}

.el-select {
	margin-right: 20px;
}

.el-tag {
	margin-right: 20px;
	height: 36px;
	line-height: 36px;
	border: none;
}

.form {
	@extend %box;
	padding: 30px;
	margin-bottom: 20px;
}

.table {
	@extend %box;
	padding: 30px;
}

.expense {
	@extend %start;
	padding: 30px 0;

	>div {
		margin-right: 30px;
	}
}

.linkwrap {
	font-size: 12px;

	&.normal {
		color: #606266;

		a {
			color: #606266;

			&:hover {
				&::after {
					height: 0.2px;
					background-color: #606266;
				}
			}

			>span {
				font-size: 12px;
				color: #606266;
			}
		}
	}
}

.description {
	@extend %start;

	div {
		&:nth-of-type(1) {
			width: 90px;
		}

		&:nth-of-type(2) {
			width: calc(100% - 150px);
		}

		&:nth-of-type(3) {
			width: 60px;
		}
	}
}

.form-title {
	line-height: 40px;
}

.vaca-form {
	el-form-item {
		.el-form-item__content {
			el-col-8 {
				margin-right: 5px;
			}
		}
	}
}

.contract-no {
	width: 100%;
	text-align: center;
	cursor: pointer;
	position: relative;

	>div {

		display: inline-flex !important;
		@extend %start;

		.circle {
			width: 12px;
			height: 12px;
			margin-right: 10px;
			cursor: pointer;
			position: absolute;
			top: 50%;
			left: 5px;
			transform: translateY(-50%);

			.circle-color {
				width: 100%;
				height: 100%;
				border-radius: 50%;
				position: absolute;
				left: 0;
			}
		}
	}
}

.color-pan {
	width: 100%;
	background: var(--card); /* 0819修改 */

	>ul {
		@extend %start;
		flex-flow: row wrap;

		li {
			@extend %center;
			width: 30px;
			height: 30px;
			border-radius: 50%;
			margin: 0 20px 20px 0;
			cursor: pointer;

			span {
				display: none;
				color: #fff;
			}

			&:hover {
				span {
					display: block;
				}
			}
		}
	}
}
</style>
<style lang="scss">
.el-table tr {
	&.warning-row {
		// background: #d1d1d1;

		.el-table__cell {
			color: #aaa;
		}
	}
}
</style>